import React, { useEffect } from 'react';
import { useSearchParams, useNavigate, useLocation} from 'react-router-dom';
import { isEmpty } from 'lodash';
import { Button, Space } from 'antd';
import Firebase from '../../lib/Firebase';
import NotFound from '../NotFound';
import Loading from '../../components/Loading';
import useWindowDimensions from '../../common/hooks/useWindowDimensions';
import DefaultPortal from './DefaultPortal';
import PartnershipForChildrenPortal from './custom-portal/PartnershipForChildrenPortal';
import PartnershipForChildrenPortalSpanish from './custom-portal/PartnershipForChildrenSpanishPortal';


function ReservationPortal({
	setLogo,
	setWebsite,
}) {
    const [searchParams] = useSearchParams();
	const currentLang = searchParams.get("lang") || "en";
    const navigate = useNavigate();
	const {pathname} = useLocation();
    const pathId = pathname.replace("/reservation/", "");
	const [fleetName, portalId, facilityId] = pathId.split("_");
	const [fleetData, loading] = Firebase.getFleetData(fleetName, portalId, facilityId);
    const windowDimensions = useWindowDimensions();

	// Used by Col span
    const isMobile = windowDimensions?.width <= 680;
	const spanWindow = isMobile ? 24 : 12;

    useEffect(() => {
        document.title = 'Reservation Portal Powered by Duet';
    }, []);

    useEffect(() => {
        if (fleetData) {
            setLogo(fleetData?.logo);
            fleetData?.website && setWebsite(fleetData?.website);
        }
    }, [fleetData, fleetName, facilityId, setLogo, setWebsite]);

    if (loading) {
		return <Loading />;
	} else if (isEmpty(fleetData) && !loading) {
		return <NotFound />;
    // Custom Reservation Portal
	} else if (fleetName === "Partnership-for-Children" && facilityId === "3c4i8k8lmbp3f75g") {
        const toggleLanguage = (lang) => {
            searchParams.set('lang', lang);
            navigate({ search: searchParams.toString() });
        };

        return (
            <div>
                <Space
                    style={{
                        position: "absolute",
                        top: "3%",
                        right: isMobile ? "2%" : "20%"
                    }}
                >
                    <Button
                        style={{
                            borderRadius: 20,
                            fontWeight: 600,
                            backgroundColor: "#D7DCE5",
                            color: "#4A525F",
                            ...(currentLang === "en" ? {backgroundColor: "#118BF0", color: "#FFFFFF"} : {})
                        }}
                        shape="round"
                        size="medium"
                        onClick={() => {
                            toggleLanguage("en");
                        }}
                    >
                        {isMobile ? "EN" : "English"}
                    </Button>
                    <Button
                        style={{
                            borderRadius: 20,
                            fontWeight: 600,
                            backgroundColor: "#D7DCE5",
                            color: "#4A525F",
                            ...(currentLang === "es" ? {backgroundColor: "#118BF0", color: "#FFFFFF"} : {})
                        }}
                        shape="round"
                        size="medium"
                        onClick={() => {
                            toggleLanguage("es");
                        }}
                    >
                        {isMobile ? "ES" : "Español"}
                    </Button>
                </Space>
                {currentLang === "es"
                    ? <PartnershipForChildrenPortalSpanish
                        fleetData={fleetData}
                        portalId={portalId}
                        facilityId={facilityId}
                        spanWindow={spanWindow}
                    />
                    : <PartnershipForChildrenPortal
                        fleetData={fleetData}
                        portalId={portalId}
                        facilityId={facilityId}
                        spanWindow={spanWindow}
                    />
                }
            </div>
        )
    } else {
        return (
            <DefaultPortal
                fleetData={fleetData}
                portalId={portalId}
                facilityId={facilityId}
                spanWindow={spanWindow}
            />
        );
    }
}

export default ReservationPortal;